// extracted by mini-css-extract-plugin
export default {"loader":"FeedPostPage_loader__InRbg","stripes-animation-background-keyframes":"FeedPostPage_stripes-animation-background-keyframes__9j7GD"};